import { ChangeEvent, useState } from 'react'
import Papa from 'papaparse'
import { GrDocumentCsv } from "react-icons/gr";

interface Props {
    handleCSV: (data: any[]) => void
}

export const ButtonCSV = ({ handleCSV }: Props) => {

    const handleCvs = (e: ChangeEvent<HTMLInputElement>) => {

        const file = e.target.files?.[0]

        if (!file) return

        Papa.parse(file, {
            header: true,
            encoding: 'UTF-8',
            transformHeader: (headerName: string) => headerName.toLowerCase(),
            complete: function (results) {

                handleCSV(results.data)
            }
        });
    }

    return (
        <label className="tw-flex tw-text-white tw-items-center tw-gap-1 tw-cursor-pointer tw-text-sm tw-px-2 tw-py-1 tw-border tw-rounded-full tw-bg-green-600">
            {/* <img src="/assets/img/csv.svg" alt="excel-logo" /> */}
            <GrDocumentCsv size={15} />

            {/* <span>Choose a CSV File</span> */}
            <span>CSV File</span>
            <input
                type="file"
                className="upload-btn"
                accept=".csv"
                id="cvsFile"
                onChange={handleCvs}
            />
        </label>
    )
}
